<template>
  <div class="warpper">
    <!-- 搜索 -->
    <div style="margin-bottom: 10px">
      <el-form :model="searchForm" ref="searchForm" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="巡更路线名称" prop="title" label-width="100px">
              <el-input
                v-model="searchForm.title"
                size="medium"
                placeholder="请输入巡更路线名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="巡更状态"
              prop="patrolLevelId"
              label-width="100px"
            >
              <el-select clearable filterable v-model="searchForm.status" placeholder="请选择状态">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-top: 4px">
            <el-button
              size="small"
              @click="onLoad(1)"
              type="primary"
              icon="el-icon-search"
              style="width: 90px; margin-left: 15px"
              >搜索</el-button
            >
            <el-button
              size="small"
              @click="restSearch"
              type="danger"
              style="width: 90px"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="patrolRouteTitle" label="巡更路线" align="center">
      </el-table-column>
      <el-table-column prop="patrolPlanTitle" label="所属计划" align="center">
      </el-table-column>
      <el-table-column prop="patrolPlanBeginTime" label="巡更计划开始时间" align="center">
      </el-table-column>
      <el-table-column prop="patrolPlanEndTime" label="巡更预计结束时间" align="center">
      </el-table-column>
      <!-- <el-table-column prop="patrolUserName" label="巡更人" align="center">
      </el-table-column> -->
      <el-table-column prop="clockIn" label="已打点/巡更点" align="center">
      </el-table-column>
      <el-table-column prop="status" label="巡更状态" align="center" :formatter="statusType">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center">
      </el-table-column>      
      <el-table-column fixed="right" align="center" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="see(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      searchForm: {
        status:""
      },
      tableData: [],
      statusList: [
        {
          id: "",
          name: "全部",
        },
        {
          id: 0,
          name: "未开始",
        },
        {
          id: 1,
          name: "待处理",
        },
        {
          id: 2,
          name: "处理中",
        },
        {
          id: 3,
          name: "已超时",
        },
        {
          id: 4,
          name: "已完成",
        },
        {
          id: 5,
          name: "超时完成",
        },
        {
          id: 6,
          name: "漏巡",
        },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    see(row){
      this.$emit('patrolTask',row)
    },
    statusType(row){
      if(row.status == 0){
        return "未开始"
      }else if(row.status == 1){
        return "待处理"
      }else if(row.status == 2){
        return "处理中"
      }else if(row.status == 3){
        return "已超时"
      }else if(row.status == 4){
        return "已完成"
      }else if(row.status == 5){
        return "超时完成"
      }else if(row.status == 6){
        return "漏巡"
      }
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(e) {
      let data = {
        size: this.pageSize,
        current: e || this.currentPage,
        ...this.searchForm,
      }
      this.isShowloading = true;
      this.$Apis.patrolTaskList(data).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>